import React, { useMemo, useState } from 'react';
import TemplatesNav from './TemplatesNav';
import Overview from './tabs/Overview';
import EmailTemplates from './tabs/EmailTemplates';
import SmsTemplates from './tabs/SmsTemplates';
import CallTemplates from './tabs/CallTemplates';

const TEMPLATE_TABS = [
    { id: 'warning', label: 'Warning', icon: 'bi-exclamation-triangle', theme: 'orange' },
    { id: 'email', label: 'Email Templates', icon: 'bi-envelope', theme: 'primary' },
    { id: 'sms', label: 'SMS Templates', icon: 'bi-chat-left-text', theme: 'cyan' },
    { id: 'call', label: 'Call Templates', icon: 'bi-telephone', theme: 'teal' },
];

function TemplateCard() {
    const [activeTab, setActiveTab] = useState('warning');
    const [loadedTabs, setLoadedTabs] = useState(() => new Set(['warning']));

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setLoadedTabs((prev) => new Set([...prev, tabId]));
    };

    const tabContent = useMemo(
        () => ({
            warning: <Overview />,
            email: <EmailTemplates />,
            sms: <SmsTemplates />,
            call: <CallTemplates />,
        }),
        []
    );

    return (
        <div className="ecx-page-card ecx-page-panel clinic-settings-panel templates-panel">
            <div className="ecx-page-panel__header templates-panel__header border-top-0">
                <TemplatesNav
                    tabs={TEMPLATE_TABS}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </div>

            <div className="ecx-page-panel__body ecx-page-scroll">
                {TEMPLATE_TABS.map((tab) =>
                    loadedTabs.has(tab.id) ? (
                        <div
                            key={tab.id}
                            className={activeTab === tab.id ? '' : 'd-none'}
                        >
                            {tabContent[tab.id]}
                        </div>
                    ) : null
                )}
            </div>
        </div>
    );
}

export default TemplateCard;
